/**
 * 客户案例
 */

export default [
    {
        path: '/customerCase',
        name: 'customerCase',
        component: () => import('../../views/customer/customerCase.vue'),
        meta: {
            title: '客户案例'
        }
    },
    {
        path: '/customerCase/:pageId',
        name: 'articleCom',
        component: () => import('../../components/articleCom.vue'),
    }
]



// WEBPACK FOOTER //
// ./src/router/customer/sustomer.js